import { render, staticRenderFns } from "./editFeeConfig.vue?vue&type=template&id=6c217f2c&scoped=true"
import script from "./editFeeConfig.vue?vue&type=script&lang=js"
export * from "./editFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./editFeeConfig.vue?vue&type=style&index=0&id=6c217f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c217f2c",
  null
  
)

export default component.exports